import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M6.848 22.848h18.304a1.152 1.152 0 010 2.304H6.848a1.152 1.152 0 010-2.304m8-6.784V5.728a1.152 1.152 0 012.304 0V16l3.648-3.68a1.15 1.15 0 011.632 0 1.15 1.15 0 010 1.632L16 20.416l-6.496-6.464a1.15 1.15 0 010-1.632c.207-.2.489-.323.8-.323s.593.123.8.323z" /></svg>;